/** Contest talent ids from API (M2M or legacy single talent). */
export function getCourseTalentIds(course) {
  if (!course) return [];
  if (course.talents && course.talents.length) {
    return course.talents.map((t) => (typeof t === "object" && t != null ? t.id : t));
  }
  if (course.talent != null) {
    return [typeof course.talent === "object" ? course.talent.id : course.talent];
  }
  return [];
}

/** User's talent id plus every parent id (matches backend / contest on parent category). */
export function collectUserTalentAncestorIds(userTalents) {
  const ids = new Set();
  for (const ut of userTalents || []) {
    if (!ut.talent) continue;
    const t = ut.talent;
    if (Array.isArray(t.ancestor_ids) && t.ancestor_ids.length) {
      t.ancestor_ids.forEach((id) => ids.add(id));
    } else {
      ids.add(t.id);
    }
  }
  return ids;
}

export function userCanParticipateInContest(userAncestorIdSet, course) {
  const contestIds = getCourseTalentIds(course);
  if (!contestIds.length) return false;
  return contestIds.some((tid) => userAncestorIdSet.has(tid));
}

/** Closed contests flagged in CMS so admin / editor / referee / test users can try them on the website. */
export function courseIsStaffPreview(course) {
  return !!(course && course.staff_preview);
}

export function courseVisibleOnDashboard(course) {
  return !!(course && (course.status || course.staff_preview));
}
